/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    bool, func, object, string, shape, arrayOf,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';

import { deepObjectExtend } from '../../../utils/object';
import { main as mainStyle } from '../../../style/main';
import SubscriptionRecipientForm from './SubscriptionRecipientForm';

const styles = ({ typography, palette }) => deepObjectExtend(mainStyle(typography, palette), {
    recipientDialogRoot: {
        width: '100%',
        boxSizing: 'border-box',
        alignItems: 'normal',
        height: '100%',
    },
    recipientDialogPaper: {
        boxSizing: 'border-box',
        borderRadius: '0',
        margin: '0 19.5px',
        boxShadow: '0px 0px 20px 6px rgba(0,0,0,0.5)',
        width: '100%',
        maxWidth: '670px',
        overflowY: 'auto',
        '@media screen and (min-width: 768px)': {
            minWidth: '55%',
            maxHeight: '600px',
            height: '91%',
        },
    },
});

function SubscriptionRecipientFormDialog({
    classes, isOpen, recipientData, selectedSubscription, closeClick, customerId, ruleId, orderItemId, handleRecipientSubmit, validZip, updateSubscriptionReduxList,
}) {
    return (
        <Dialog
            data-testid="subscription-recipient-form-modal"
            open={isOpen}
            classes={{
                root: classes.recipientDialogRoot,
                paper: classes.recipientDialogPaper,
            }}
        >
            <SubscriptionRecipientForm
                validZip={validZip}
                orderItemId={orderItemId}
                customerId={customerId}
                ruleId={ruleId}
                closeForm={closeClick}
                subscription={selectedSubscription}
                recipientAddress={recipientData}
                handleRecipientSubmit={handleRecipientSubmit}
                updateSubscriptionReduxList={updateSubscriptionReduxList}
            />
        </Dialog>
    );
}

SubscriptionRecipientFormDialog.propTypes = {
    classes: object.isRequired,
    recipientData: shape({
        productId: string.isRequired,
        ruleId: string.isRequired,
        recipient: arrayOf(
            shape({
                city: string.isRequired,
                country: string.isRequired,
                firstName: string.isRequired,
                lastName: string.isRequired,
                state: string.isRequired,
                street1: string.isRequired,
                street2: string.isRequired,
                zipcode: string.isRequired,
            }),
        ),
    }),
    closeClick: func,
    isOpen: bool,
    customerId: string,
    orderItemId: string,
    ruleId: string,
    handleRecipientSubmit: func.isRequired,
    validZip: string.isRequired,
    updateSubscriptionReduxList: func.isRequired,
    selectedSubscription: object.isRequired,
};
SubscriptionRecipientFormDialog.defaultProps = {
    customerId: string,
    ruleId: string,
    orderItemId: string,
    isOpen: false,
    closeClick: () => {},
    recipientData: {},
};
export default withStyles(styles, { withTheme: true })(SubscriptionRecipientFormDialog);
